import { PARTIALLY_SUPPORTED_PLATFORMS, SOCIAL_PLATFORMS } from '~/constants';

import { ApiModule } from './clientApi.model';

export enum SOCIAL_PLATFORM_PIPELINE_STATUS {
  pending = 'pending',
  finished = 'finished',
  invalid = 'invalid',
  duplicated = 'duplicated',
}

export interface CreatorOffPlatformCommon {
  lastUpdatedAt?: string;
  pipelineStatus?: SOCIAL_PLATFORM_PIPELINE_STATUS;
}

export interface CreatorOffPlatformInstagram extends CreatorOffPlatformCommon {
  followersCount?: number;
  followsCount?: number;
  handle?: string;
  lastUpdatedAt?: string;
  mediaCount?: number;
  name?: string;
  profilePicUrl?: string;
}

export interface CreatorOffPlatformTiktok extends CreatorOffPlatformCommon {
  displayName?: string;
  followersCount?: number;
  likesCount?: number;
  profileImage?: string;
  tiktokHandle?: string;
  videosCount?: number;
}

export interface CreatorOffPlatformSnapchat extends CreatorOffPlatformCommon {
  displayName?: string;
  followersCount?: number;
  snapUserName?: string;
  profileUrl?: string;
}

export interface OffPlatformPlatforms {
  [SOCIAL_PLATFORMS.instagram]: CreatorOffPlatformInstagram;
  [SOCIAL_PLATFORMS.tiktok]: CreatorOffPlatformTiktok;
  [PARTIALLY_SUPPORTED_PLATFORMS.snapchat]: CreatorOffPlatformSnapchat;
}

export interface OffPlatformApiModule extends ApiModule {
  deleteCreator: (params: { id: string }) => Promise<any>;
}
